import { render, staticRenderFns } from "./collegeTree.vue?vue&type=template&id=13e6ff3d&scoped=true&"
import script from "./collegeTree.vue?vue&type=script&lang=js&"
export * from "./collegeTree.vue?vue&type=script&lang=js&"
import style0 from "./collegeTree.vue?vue&type=style&index=0&id=13e6ff3d&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e6ff3d",
  null
  
)

export default component.exports